import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	title: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	titleWithServicename: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	serviceName: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	errorTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	errorDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	title: {
		id: 'servicedesk-object-active-incidents-panel.active-incident-panel.title',
		defaultMessage:
			'{incidentCount, plural, one {1 open incident} other {{incidentCount} open incidents}} on this service',
		description: 'Title of the open incidents panel',
	},
	titleWithServicename: {
		id: 'servicedesk-object-active-incidents-panel.active-incident-panel.title-with-servicename',
		defaultMessage:
			'{incidentCount, plural, one {1 open incident} other {{incidentCount} open incidents}} on {serviceName}',
		description:
			'Title of the open incidents panel with the name of the service which this panel is for',
	},
	serviceName: {
		id: 'servicedesk-object-active-incidents-panel.active-incident-panel.service-name',
		defaultMessage: '’{serviceName}’',
		description: 'Service name in apostrophes',
	},
	errorTitle: {
		id: 'servicedesk-object-active-incidents-panel.active-incident-panel.error-title',
		defaultMessage: "There's been a problem loading a panel",
		description: 'Title of the panel when there is an error',
	},
	errorDescription: {
		id: 'servicedesk-object-active-incidents-panel.active-incident-panel.error-description',
		defaultMessage: 'Try refreshing the page.',
		description: 'Description of the panel when there is an error',
	},
});
export default messages;
